<template>
  <div
    :id="val"
    class="position-relative"
    @click="onClickTab"
  >
    <div class="tab" :class="{ 'active-tab': isActive }">
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent, inject, state, toRefs } from "vue";

export default defineComponent({
  name: "TabButton",
  props: {
    val: {
      default: '',
      type: String,
    },
    label: {
      default: '',
      type: String,
    },
    indicator: {
      default: false,
      type: Boolean,
    },
    isActive: {
      default: false,
      type: Boolean,
    },
  },
  setup(props) {
    const tabs = inject(
      "tabs",
      {
        activeTab: () => {},
      },
    );
    function onClickTab() {
      tabs.activeTab(props.val);
    }
    return {
      ...toRefs(state),
      tabs,
      onClickTab,
    };
  },
});
</script>
<style scoped>
.tab {
  cursor: pointer;
  padding: 0 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-width: 1px;
  height: 40px;
}
.active-tab {
  border-style: solid;
  border-color: #ccc;
  border-bottom-color: #fff;
  border-radius: 4px 4px 0 0;
}
</style>
